import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Typography } from '@mui/material';
import { Title, Text, BarChart } from 'shared/components';
import numeral from 'numeral';
import { SEGMENT_FILTER_FIELD } from '../../utils/cube/constants';
import ReportingDetails from '../ReportingDetails';
import { ChartsRow, Col, Container, Item, Row, Scroller } from './styles';
import { getDetails } from '../../actions';
import { TitleCard, TitleCardValues, LinkMore, TitleTotal } from '../styles';

export const ReportingCard = React.memo(({ total, completed, yearsData, general, settings, expanded, totals }) => {
	const dispatch = useDispatch();
	const { loading, list } = useSelector((state) => state.details);
	const { accountId } = useSelector((state) => state.profile.me);
	const [ openDetails, setOpenDetails ] = React.useState(false);
	const [ showMore, setShowMore ] = React.useState({});
	const percentage = completed / total * 100;

	const handleShowMore = (blockId) => {
		const status = !(showMore[blockId]);
		return setShowMore({[blockId]: status});
	};

	const handleCloseMoreDetails = () => {
		setOpenDetails(false);
	};

	const handleOnClickSegment = (segment) => {
		setOpenDetails(false);
		setTimeout(() => {
			setOpenDetails(true);
		}, 100);
		const field = SEGMENT_FILTER_FIELD[settings.segment];
		const options = { accountId };
		options[field] = segment;
		dispatch(getDetails(options));
	};

	return (
		<Container expanded={expanded}>
			{total === 0 && (
				<Grid container direction="row" justify="center" alignItems="center" spacing={1}>
					<Text style={{ width: '100%', marginTop: 160 }} centered>
						No data matching your filters, please change your card settings and try again.
					</Text>
				</Grid>
			)}
			{total > 0 && (
				<Row>
					<Col>
						<TitleCard gutterBottom>
							for a total of {totals.reports} programs, there are {' '}
							{numeral(percentage).format('0')}% ({completed} out of {total}){' '}
							of funded reports in your active portfolios are completed	
						</TitleCard>
					</Col>
					{total > 0 && (
						<Col>
							<BarChart data={general} height="110px" />
						</Col>
					)}
				</Row>
			)}
			{total > 0 &&
				yearsData.map((year, i) => (
					<ChartsRow key={i}>
						<TitleCard>
							{year.title}
						</TitleCard>
						{year.rows.length > 0 && (
							<Scroller>
								{ (showMore[year.title] ? year.rows : year.rows.slice(0, 6)).map((row, idx) => (
									<Item key={idx} onClick={() => handleOnClickSegment(row.title, i)}>
										<BarChart {...row} />
									</Item>
								))}
								{(year.rows.length > 6) && !showMore[year.title] && (
									<LinkMore onClick={() => handleShowMore(year.title)}>Show {year.rows.length - 6} more...</LinkMore>
								)}
								{showMore[year.title] && (<LinkMore onClick={() => handleShowMore(year.title)}>Show Less</LinkMore>)}
							</Scroller>
						)}
						{openDetails && (
							<ReportingDetails loading={loading} list={list} onClose={() => handleCloseMoreDetails(i)} />
						)}
					</ChartsRow>
				))}
		</Container>
	);
});

ReportingCard.propTypes = {
	total: PropTypes.number,
	completed: PropTypes.number,
	yearsData: PropTypes.array,
	general: PropTypes.array,
	settings: PropTypes.object
};
